(ns ui.editors.card.entity-list.event
  (:require
   [re-frame.core :as rf]
   [common.util :as cu]
   [ui.editors.card.entity-list.model :as model]))

(rf/reg-event-fx
 ::add-table-column
 [rf/trim-v]
 (fn [{:keys [db]} [added-field]]
   {:db (update-in db model/table-columns-path (fnil conj []) {:field added-field})}))

(rf/reg-event-fx
 ::remove-table-column
 [rf/trim-v]
 (fn [{:keys [db]} [removed-field]]
   (let [sort-by-field (get-in db model/table-sort-by-field-path)
         group-by-field (get-in db model/table-group-by-field-path)

         new-db (cond-> db
                  true (update-in model/table-columns-path
                                  (fn [prev-cols]
                                    (->> prev-cols
                                         (filterv
                                          (fn [{:keys [field]}]
                                            (not= field removed-field))))))

                  (= sort-by-field removed-field)
                  (assoc-in model/table-sort-by-field-path nil)

                  (= group-by-field removed-field)
                  (assoc-in model/table-group-by-field-path nil))]
     {:db new-db})))

(rf/reg-event-fx
 ::reorder-table-columns
 [rf/trim-v]
 (fn [{:keys [db]} [start-idx end-idx]]
   {:db (update-in db model/table-columns-path cu/vec-move start-idx end-idx)}))

(rf/reg-event-fx
 ::set-table-sort-by-field
 [rf/trim-v]
 (fn [{:keys [db]} [field]]
   {:db (assoc-in db model/table-sort-by-field-path field)}))

(rf/reg-event-fx
 ::set-table-sort-direction
 [rf/trim-v]
 (fn [{:keys [db]} [direction]]
   {:db (assoc-in db model/table-sort-direction-path direction)}))

(rf/reg-event-fx
 ::set-table-group-by-field
 [rf/trim-v]
 (fn [{:keys [db]} [group-by-field]]
   {:db (assoc-in db model/table-group-by-field-path group-by-field)}))

(rf/reg-event-fx
 ::set-entity-peek-visible-fields-strategy
 [rf/trim-v]
 (fn [{:keys [db]} [visible-fields-strategy]]
   {:db (assoc-in db model/entity-peek-visible-fields-strategy-path visible-fields-strategy)}))


(rf/reg-event-fx
 ::add-entity-peek-visible-field
 [rf/trim-v]
 (fn [{:keys [db]} [field]]
   {:db (update-in db model/entity-peek-visible-fields-path (fnil conj []) {:field field})}))

(rf/reg-event-fx
 ::remove-entity-peek-visible-field
 [rf/trim-v]
 (fn [{:keys [db]} [removed-field]]
   {:db (update-in db model/entity-peek-visible-fields-path
                   (fn [visible-fields]
                     (->> visible-fields
                          (remove #(= (:field %) removed-field))
                          vec)))}))

(rf/reg-event-fx
 ::reorder-entity-peek-visible-fields
 [rf/trim-v]
 (fn [{:keys [db]} [start-idx end-idx]]
   {:db (update-in db model/entity-peek-visible-fields-path cu/vec-move start-idx end-idx)}))
